import PlaceTeaser from "./PlaceTeaser";

export default function Places(props) {
  if (props.data.length > 0) {
    return (
      <div>
        {props.data.map(function (place, index) {
          const style = {
            border:
              props.activeIndex === index
                ? "inset 0 0 0 2pt #988046"
                : "1px 2px 4px rgba(0, 0, 0, 0.2)",
            opacity: props.activeIndex === index ? "1" : "0.5",
          };
          return (
            <PlaceTeaser
              key={place.nid}
              place={place}
              // CTA={props.CTA}
              CTA={place.CTA}
              data={props.data}
              gallery={place.image_gallery}
              extension={place.extension}
              inProp={props.inProp}
              activeStyle={style}
            />
          );
        })}
      </div>
    );
  } else {
    return <div>Loading...</div>;
  }
}
